<template>
  <div id='login'>
      <div class='login-content'>
            <div class='title'>怀天康世-后台管理系统</div>
            <div class='subtitle'></div>
            <div class='loginform'>
                <div class='login-input'>
                    <div class='login-input-icon'><Icon src='user' class='login-input-svg'/></div><div class='login-input-content'> <el-input type='text' v-model='username' placeholder="请输入用户名"  @keyup.enter.native='doLogin' ></el-input></div>
                </div>
                <div class='login-input'>
                    <div class='login-input-icon'><Icon src='password' class='login-input-svg'/></div><div class='login-input-content'> <el-input type='password' v-model='password' placeholder="请输入密码" @keyup.enter.native='doLogin' ></el-input></div>
                </div>
                <div class='login-btn'>
                        <el-button type="primary" @click='doLogin()' class='login-btn-self' size="medium">登  陆</el-button>
                </div>    
            </div>    
            <div class='bottomwords'>copyright@2024</div>
      </div>
  </div>
</template>
<script>
import Icon from '@/components/icon'

export default {
   name: 'login',
   data() {
        return {
          username:'',
          password:''
        };
   }, 
   methods: {
      doLogin(){
          if(this.username=='') {
              this.$message("用户名不能为空")
              return false
          }
          if(this.password=='') {
              this.$message("密码不能为空")
              return false
          }

          this.$store.dispatch("doLogin",{username:this.username,password:this.password}).then((data)=>{
              if(data.result.success){
                  if(parseInt(data.result.info.ismobile)==1){
                      this.$store.commit("TOGGLE_SIDEBAR",{isCollapse:true})
                  }else{
                      this.$store.commit("TOGGLE_SIDEBAR",{isCollapse:false})
                  }
                  this.$go('/')
              }else{
                  this.$message(data.result.info);return false;
              }
          })
      }
   },
   components: {
        Icon
   }
}
</script>
<style scoped>
#login{background-color:#2d3a4b;min-height: 100vh;padding-top:60px;z-index:999;padding: 0 0.3rem;overflow:hidden;position: relative;color:#ffffff;margin: 0 auto;text-align: center;display: flex;align-items: center;}
.login-content{width:5rem;margin: 0 auto;}
.logo{margin-top:0.05rem;}
.logoimg{width:100%;width:2rem;height:2rem;}
.subtitle{font-size:0.12rem;padding: 0 0.1rem 0.1rem;}
.login-btn{margin-top: 0.2rem;}
.login-input-icon{width:0.6rem;text-align: center;padding:0.15rem;box-sizing: border-box;}
.login-input-svg{width:0.25rem;height:0.25rem;}
.login-input-content{flex:3;}
.bottomwords{position: absolute;width: 100%;text-align: center;left:0;bottom:0;font-size:0.15rem;}
::placeholder {color: #C0C4C3;font-size: 0.20rem;}
::v-deep .el-input__inner{outline: none;border: none;background-color: #283443;height:0.3rem;line-height: 0.3rem;width:100%;font-size:0.20rem;color:#fff;padding:0;}
.title{font-size:0.33rem;font-weight: 600;padding: 0.1rem;}
.login-input{height:0.5rem;margin-top: 0.15rem;border-radius: 0.1rem;display:flex;align-items: center;padding:0.1rem 0;border: 1px solid hsla(0,0%,100%,.1);background: rgba(0,0,0,.1);}
.login-btn-self{width:100%;font-size:0.20rem;padding: 0.12rem;}

@media screen and (max-width:767px){
    .title{font-size:0.4rem;font-weight: 600;padding: 0.1rem;}
    .login-input{height:0.8rem;margin-top: 0.15rem;border-radius: 0.1rem;display:flex;align-items: center;padding:0.1rem 0;border: 1px solid hsla(0,0%,100%,.1);background: rgba(0,0,0,.1);}
    .login-btn-self{width:100%;font-size:0.25rem;padding: 0.20rem;}
    ::v-deep .el-input__inner{font-size:0.25rem;}
    .login-input-svg{width:0.26rem;height:0.26rem;}
    .login-input-icon{width:0.66rem;}
}
</style>